import store from '../app/store';
import { addNotify } from '../redux/notifyAction';

const valid = (wResponse, ns) => {
	if (wResponse.isError) {
		if (ns !== false) {
			store.dispatch(addNotify(wResponse.reasons, ns));
		}
		return false;
	} else {
		return true;
	}
};

export default valid;
